import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import Swal from "sweetalert2";
import { AddDocumentsComponent } from "../components/document/documents/add-documents/add-documents.component";
import { GlobalService } from "../services/global.service";

@Injectable()
export class CanDeactivateAddDocuments  {
  constructor(private translate : TranslateService) {}

   async canDeactivate(component: AddDocumentsComponent, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState: RouterStateSnapshot) {
    let risposta : boolean;        
    if(currentRoute.data["isSaved"] == true){          
      // In caso di salvataggio fattura ricarica i dati della dashboard
      GlobalService.LoadDashBoardInfoFromUserService();
      return true;
    }
    await Swal.fire({
      title: this.translate.instant("GENERIC_LABEL.ATTENTION"),
      text: this.translate.instant("DIALOGS.EXIT_WITHOUT_SAVE"),
      icon : 'warning',
      showConfirmButton : true,
      showDenyButton : true,
      denyButtonText : this.translate.instant("GENERIC_LABEL.ABORT"),
      confirmButtonText : this.translate.instant("GENERIC_LABEL.CONFIRM")
    }).then(res => {
      if(res.isConfirmed){
        risposta = true;
      }else{
        risposta = false;
      }
    })
    return risposta;
  }
}
